import { ChallengeFormType, FormValidator } from '../../NewChallengeForm.types';

type Params = Pick<ChallengeFormType, 'challengeStickers'>;

export const validate: FormValidator<Params> = () => {
  return { isValid: true };
};
